import { Context } from "./context";
import * as cv from "../opencv.js";
import React, { useState, useEffect, useRef } from "react";
import * as RB from "react-bootstrap";
import { createSlice } from "@reduxjs/toolkit";
import { useSelector, useDispatch, useStore } from "react-redux";
import { wrapLoading } from "./loading-animation";
export const filterToolSlice = createSlice({
    name: "filterTool",
    initialState: {
        radius: 1,
    },
    reducers: {
        initState: (state, action) => {
            state.radius = 1;
        },
        updateRadius: (state, action) => {
            let newRad = action.payload.radius;
            if (newRad > 0 && newRad < 100) {
                state.radius = newRad;
            }
        },
    },
});
export const { initState, updateRadius } = filterToolSlice.actions;
export const FilterProps = (props) => {
    /**@type {Context} */
    const context = props.context;
    const radius = useSelector((state) => state.filterTool.radius);
    const dispatch = useDispatch();
    const store = useStore();
    const radRef = useRef(null);
    useEffect(()=>{
        radRef.current.addEventListener('change',(event)=>{
            changeHandle(event);
            radRef.current.value = store.getState().filterTool.radius;
        })
    },[])
    useEffect(()=>{
        radRef.current.value = radius;
    },[radius])
    const medianCv = (radius) => {
        let w = context.offScrCnv.width,
            h = context.offScrCnv.height;
        let src = cv.matFromImageData(
            context.offScrCnvCtx.getImageData(0, 0, w, h)
        );
        let blured = new cv.Mat();
        cv.medianBlur(src, blured, radius * 2 + 1);
        let res = new ImageData(w, h);
        res.data.set(blured.data);
        src.delete();
        blured.delete();
        return res;
    };
    const changeHandle = (event) => {
        let newRad = Math.round(Number(event.target.value));
        dispatch(updateRadius({ radius: newRad }));
    };
    const applyHandle = (event) => {
        wrapLoading(() => {
            console.time("Median apply");
            // let newData = this.median(this.#radius);
            let newData = medianCv(radius);
            context.offScrCnvCtx.putImageData(newData, 0, 0);
            console.timeEnd("Median apply");
            context.updateImage();
            context.putToHistory();

            console.log(`Median with radius ${radius} applied`);
        });
    };
    const resetHandle = (event) => {
        dispatch(initState({}));
    };
    const form = (
        <RB.Form>
            <RB.FormGroup className="toolprop">
                <RB.Form.Row>
                    <RB.Col>
                        <RB.Form.Label>Радиус:</RB.Form.Label>
                    </RB.Col>
                    <RB.Col md={7}>
                        <RB.Form.Control
                            ref={radRef}
                            type="number"
                            size="sm"
                            // value={radius}
                            // onChange={changeHandle}
                            id="filter-radius"
                        ></RB.Form.Control>
                    </RB.Col>
                </RB.Form.Row>
                <RB.Form.Row className="button-row">
                    <RB.Button
                        id="filter-apply"
                        onClick={applyHandle}
                        size="sm"
                    >
                        Применить
                    </RB.Button>
                    <RB.Button
                        id="filter-reset"
                        onClick={resetHandle}
                        size="sm"
                    >
                        Сброс
                    </RB.Button>
                </RB.Form.Row>
            </RB.FormGroup>
        </RB.Form>
    );
    return form;
};
